<template>
  <div class="bg">
    <div class="x">
      <b-img src="../assets/result/x.png" @click="close" />
    </div>
    <p class="headertext">คำทำนายของคุณ</p>
    <b-img :src="prayer" class="imgzodiac" />
    <div class="box">
      <carousel>
        <slide>
          <p class="ttext">การงาน</p>
          <div class="text">{{ zodiacresult.job }}</div>
        </slide>
        <slide>
          <p class="ttext">การเงิน</p>
          <div class="text">
            {{ zodiacresult.money }}
          </div>
        </slide>
        <slide
          ><p class="ttext">ความรัก</p>
          <div class="text">
            {{ zodiacresult.love }}
          </div>
        </slide>
        <slide>
          <p class="ttext">สุขภาพ</p>
          <div class="text">
            {{ zodiacresult.health }}
          </div></slide
        >
      </carousel>
    </div>
    <div style="padding-bottom:100px;">
      <b-img
        style="margin-top: 30px"
        src="../assets/result/share.png"
        @click="close"
      />
      
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";

export default {
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      prayer: "",
      zodiacresult: "",
      result: [
        {
          job:
            "บทบาทของคุณในช่วงนี้มักจะเป็นผู้ให้คำปรึกษา หรือถ่ายทอดความรู้ในเรื่องงานที่คุณมีความเชี่ยวชาญมากกว่าที่จะลงมือทำงานด้วยตัวเอง ได้ลูกน้อง ลูกจ้างที่มีความสามารถ ช่วยจัดการภาระต่าง ๆ ได้",
          money:
            "สถานะการเงินมีความมั่นคงขึ้น เก็บออมได้มากขึ้น จัดการภาระหนี้สินต่าง ๆ ได้ตามเวลา เพราะคุณมีวินัยที่ดีในเรื่องการใช้จ่ายมากขึ้น สบายอกสบายใจได้ ถึงแม้รายได้จะไม่ได้เพิ่มขึ้นเท่าใดก็ตาม",
          love:
            "อาจต้องเพิ่มเติมความหวานให้ชีวิตคู่บ้าง ความที่มีกิจกรรม เจอผู้คนมากหน้าหลายตา ต้องระวังท่าทีที่มีต่อบางคนที่อาจดูเกินเพื่อนไป ทำให้คนรักน้อยใจ เกิดปัญหาเข้าใจผิด ส่วนคนโสด ช่วงนี้เสน่ห์แรง",
          health:
            "ขี้หลงขี้ลืมมากกว่าปกติ มึน ๆ งง ๆ บ่อย ควรดื่มน้ำให้มากขึ้น ออกกำลังกายกลางแจ้งโดนแดดบ้าง",
        },
        {
          job:
            "กิจกรรมเกี่ยวกับงานมีความหลากหลายมากขึ้น ได้พบปะผู้คนกลุ่มใหม่ ๆ สนุกสนานกับการทำงานมาก ได้เพื่อนร่วมงานที่ถูกคอถูกใจกันดีมาก มีการตกแต่งสถานที่ทำงานใหม่ จัดโต๊ะทำงานใหม่ บรรยากาศดี",
          money:
            "มีค่าใช้จ่ายที่ไม่ได้คาดคิดเกิดขึ้นเยอะ รายได้ที่ควรจะเข้าบัญชีมีอันต้องเลื่อนไปหลายรายการ ได้รับเงินช้ากว่าที่คาดไว้ ทำให้การเงินสะดุดบ้าง เครียดสักหน่อย ช่วงปลายเดือนจะเข้าที่เข้าทาง ราบรื่นขึ้น",
          love:
            "เป็นความสัมพันธ์ที่สบาย ๆ ให้พื้นที่ส่วนตัวแก่กันในจังหวะที่พอดี ๆ เป็นคู่รักที่ไม่ได้ตัวติดกันมาก แต่รู้สึกอบอุ่นใจเสมอว่ามีกันอยู่ คนโสด ไม่ได้มีปัญหาว่าจะต้องมีแฟนแต่อย่างใด มีเพื่อนก็โอเคแล้ว",
          health:
            "หลีกเลี่ยงการใช้สารเคมีและทำศัลยกรรม อาจเกิดปัญหาต้องจัดการบำบัดรักษา แก้ไขหลายรอบ",
        },
        {
          job:
            "เกิดสถานการณ์ภายในองค์กรที่คุณทำงานอยู่ ที่ทำให้คุณต้องทำใจร่ม ๆ ค่อย ๆ ตั้งสติในการจัดการอะไรต่าง ๆ บทบาทหน้าที่ของคุณอาจเปลี่ยนแปลงไปเล็กน้อย เป็นคนที่ผู้ร่วมงานมองว่าคุณเป็นที่พึ่งพิงได้",
          money:
            "วางแผนการเงินไว้ดี รายรับ-รายจ่ายค่อนข้างสมดุล และคุณยังใจดี ช่วยเหลือเกื้อกูลคนอื่นที่เดือดร้อนอีกด้วย ซึ่งคุณต้องมีหลักฐานในการให้คนอื่นกู้ยืมเป็นลายลักษณ์อักษร ป้องกันปัญหาภายหลัง",
          love:
            "ผู้ที่มีคนรักแล้ว อาจต้องดูแลเอาใจใส่เขามากขึ้น เพราะเขามีปัญหาเครียดและสุขภาพไม่ค่อยจะดีนัก บางทีคุณเองก็อารมณ์หงุดหงิดง่าย ต้องระวังเกิดปากเสียงในเรื่องที่ไม่เป็นเรื่อง ส่วนคนโสดจะเหงา ๆ หน่อย",
          health:
            "ร่างกายโดยรวมไม่มีปัญหา แต่นอนไม่ค่อยหลับ มีอาการอ่อนเพลียง่าย ดูจะขี้หลงขี้ลืมมากกว่าปกติ",
        },
        {
          job:
            "มีความเปลี่ยนแปลงเล็กน้อยในหน้าที่การงาน เป็นเรื่องที่คุณต้องตัดสินใจเลือกทางใดทางหนึ่ง ซึ่งไม่ว่าจะตัดสินใจอย่างไรผลก็จะดี การจัดที่ทำงาน โต๊ะทำงาน จัดมุมห้องนอนใหม่ ช่วยเสริมพลังเรื่องงานได้ดี",
          money:
            "สบายใจเรื่องเงิน รายได้หลักอยู่ในระดับเดิม แต่จะมีรายได้เพิ่มพิเศษจากธุรกิจเสริม ค่าใช้จ่ายส่วนใหญ่จะเป็นเรื่องการเรียน การศึกษาพิเศษ และการช่วยเหลือลูกหลาน ลูกน้อง ลูกจ้าง มีโชคลาภเล็กน้อย",
          love:
            "ความสัมพันธ์ราบรื่น เข้าใจกันและกันดี แม้ไม่ค่อยมีเวลาใกล้ชิดกันเท่าไหร่ คนโสดมีความสุขแบบโสด ๆ อาจมีการติดต่อทำความรู้จักกับคนต่างชาติต่างถิ่นบ้าง แต่สถานะความสัมพันธ์ไม่ชัดเจน",
          health:
            "โรคประจำตัวออกฤทธิ์เป็นช่วง ๆ ต้องดูแลสุขภาพมากขึ้น พักผ่อนให้พอ ระวังอาหารการกินให้ดี ๆ",
        },
        {
          job:
            "บทบาทหน้าที่การงานช่วงนี้ของคุณมักจะต้องดูแลแทบทุกเรื่อง เป็นที่พึ่งพิงของผู้อื่น ไม่ว่าจะเป็นการให้ความรู้ ให้คำปรึกษา การแก้ปัญหาต่าง ๆ แม้กระทั่งเจ้านายยังฝากความหวังไว้ที่คุณเลย",
          money:
            "ได้ทำบุญบริจาคทานการกุศลบ่อย ๆ การเงินหลัก ๆ เป็นไปตามที่คาด รายได้-รายจ่ายไม่ค่อยมีอะไรผิดแผน ยกเว้นเรื่องที่เป็นความเสี่ยง ช่วงนี้ยังไม่มีโชคลาภจากการเสี่ยงใด ๆ เลี่ยงการเล่นหุ้น เล่นหวย หรือเล่นทอง",
          love:
            "ผู้ที่แต่งงานแล้ว ยังรอคอยข่าวเรื่องมีลูก เดือนนี้มีเกณฑ์ได้ข่าวดี ส่วนคู่รักที่คบหากันมาสักพัก มีเกณฑ์ที่จะตกลงใช้ชีวิตคู่ร่วมกัน คนโสด มีเปอร์เซ็นต์สูงที่จะได้พบคนที่ถูกใจและคบหาพัฒนาความสัมพันธ์",
          health:
            "ได้พบแนวทางการดูแลสุขภาพที่เหมาะกับตัวเอง ทั้งสุขภาพร่างกายและสุขภาพใจ แข็งแรงมากขึ้น",
        },
        {
          job:
            "อะไรต่าง ๆ ที่วางแผนไว้ มีอันต้องปรับเปลี่ยนตามสถานการณ์ ที่มีเหตุปัจจัยนอกเหนือการควบคุมของเรา อาจต้องเปลี่ยนสถานที่ทำงานชั่วคราว ต้องระงับแผนการเดินทาง และเลื่อนกิจกรรมต่าง ๆ ออกไป",
          money:
            "รายได้หลัก ๆ ลดลงไปบ้าง แต่รายได้เสริมมาจากหลายทาง ช่วยประคับประคองให้สามารถใช้จ่ายเรื่องจำเป็นต่าง ๆ ได้ ต้องประหยัดอดออมมากขึ้น ต้องวางแผนสำหรับค่าใช้จ่ายในการดูแลผู้ใหญ่ที่เจ็บป่วย",
          love:
            "มีความเป็นผู้ใหญ่ คุยกันด้วยเหตุด้วยผลมากขึ้นกว่าที่ผ่านมา ให้อิสระกันและกัน มีพื้นที่ส่วนตัวมากขึ้น คนโสดจะมีคนที่อายุมากกว่าให้ความสนใจเข้ามาทำความรู้จัก แต่ดูเหมือนคุณจะยังอยากโสดต่อ",
          health:
            "ควรหาเวลาออกกำลังกาย หรือทำกิจกรรมที่เป็นการผ่อนคลายความเครียด ช่วงนี้ระวังอ้วนง่าย",
        },
        {
          job:
            "สามารถรับมือจัดการกับปัญหาต่าง ๆ ที่เกิดขึ้นมากมายในช่วงนี้ เหนื่อยกาย เหนื่อยใจ แต่ผลสำเร็จคุ้มค่ากับการลงมือลงแรง ระวังขัดแย้งกับผู้ร่วมงานที่เป็นเจ้านาย หรือคนที่มีตำแหน่งสูงกว่า",
          money:
            "ลูกหนี้ค่อนข้างเหนียวหนี้กับเรา แต่เจ้าหนี้ของเรามีความเป๊ะ คุณอยู่ในสภาวะที่ต้องลุ้นเรื่องเงินที่จะมาเข้ากระเป๋าซึ่งอาจจะช้ากว่าที่ควร แต่ยังทันเวลาที่จำเป็นต้องใช้จ่าย จึงเครียดเรื่องเงินเป็นช่วง ๆ",
          love:
            "พักนี้คุณกับคนรักมักมีเรื่องระหองระแหงเล็ก ๆ เสมอ ระวังเรื่องเล็กกลายเป็นเรื่องใหญ่ หากปรับใจเข้าหากันอย่างมีเหตุผล จะสามารถไปต่อได้อย่างมั่นคงขึ้น คนโสดระวังคนมีเจ้าของแล้วเข้ามาจีบ พิจารณาดี ๆ",
          health:
            "ปวดเมื่อยร่างกายบริเวณหลัง ไหล่ อ่อนเพลียง่าย อารมณ์หดหู่กว่าปกติ ควรบริหารร่างกายบ่อย ๆ",
        },
        {
          job:
            "ทำงานอย่างสบายใจ ผลการดำเนินงานค่อย ๆ มีความคืบหน้าไปตามที่ควรจะเป็น เรื่องที่ลงทุนลงแรงไว้นานแล้วจะออกดอกออกผลงอกเงยให้ชื่นใจ เป็นแรงบันดาลใจให้ตัวเองมีช่องทางต่อยอดได้อีกยาว ๆ",
          money:
            "รายได้ค่อนข้างสวนทางกับปริมาณงาน กว่าจะเรียกเก็บเงินที่ควรจะได้เข้ากระเป๋าของเราต้องออกแรงมากหน่อย ลูกหนี้ผิดนัดผิดเวลา ค่าใช้จ่ายเกี่ยวกับสุขภาพ ค่าหมอ ค่ายา ค่าเบี้ยประกัน เพิ่มขึ้นกว่าปกติ",
          love:
            "คนรักช่วยดูแลเอาใจใส่คุณเป็นอย่างดี แม้บางครั้งตัวคุณเองจะค่อนข้างเอาแต่ใจ เขาก็ยังคงเข้าใจคุณเสมอ คุณผู้หญิงยังโสด จะมีคนอายุน้อยกว่ามาชอบ ส่วนคุณผู้ชายโสด จะมีคนอายุมากกว่ามาชอบ",
          health:
            "หลีกเลี่ยงการนอนดึก ควรกินอาหารให้ถูกเวลา ระวังอาการกรดไหลย้อน ผิวเป็นผดผื่น ลมพิษ",
        },
        {
          job:
            "แม้ว่าระบบงานจะมีความลงตัว ดำเนินไปได้เรื่อย ๆ แต่ช่วงนี้คุณมีเรื่องส่วนตัวที่ต้องจัดการค่อนข้างมาก การงานจึงต้องพึ่งพาทีมที่ดี ได้ลูกน้อง ลูกจ้าง สามารถช่วยแบ่งเบาภาระงานของคุณได้มาก",
          money:
            "ต้องบริหารจัดการบัญชีรายรับ-รายจ่ายอย่างรอบคอบและใช้จ่ายให้ได้ตามแผนที่วางไว้ จะมีค่าใช้จ่ายที่ไม่คาดคิดเพิ่มเข้ามา โดยที่รายได้ยังคงเดิม จึงต้องสำรองเงินไว้สำหรับเรื่องจำเป็นจริง ๆ",
          love:
            "ท่าทีที่เปลี่ยนแปลงไปของคนรัก ทำให้คุณคิดมาก กังวลไปต่าง ๆ นานา อารมณ์เศร้าหมอง บางเรื่องคุณอาจคิดมากไปเอง แต่บางเรื่องที่สังหรณ์ใจก็อาจจะจริงตามนั้น คนโสดที่แอบชอบใครข้างเดียวอยู่ต้องทำใจ",
          health:
            "ร่างกายไม่ค่อยมีปัญหาอะไร แต่อารมณ์เครียดไปหน่อย ผิวพรรณไม่สดใส การออกกำลังกายช่วยได้",
        },
        {
          job:
            "นอกจากงานประจำ งานหลักแล้ว ช่วงนี้คุณยังมีงานเสริมพิเศษด้วย โดยงานที่เสริมพิเศษนั้นไม่ใช่งานที่เน้นเรื่องรายได้เท่าใดนัก ส่วนมากจะเป็นเรื่องที่ได้ช่วยเหลือสังคมส่วนรวม เป็นงานที่ทำแล้วอิ่มใจ",
          money:
            "มีใช้จ่ายอย่างสบาย ๆ แบบไม่ต้องวิตกกังวล สามารถเก็บออมได้ตามที่คิดไว้ ยังมีส่วนที่สามารถแบ่งปัน บริจาคเพื่องานบุญ งานกุศลได้ด้วย ภาระหนี้สินต่าง ๆ คลี่คลายลงไปในระดับที่สามารถจัดการได้แบบไม่เครียด",
          love:
            "แม้จะดูเหมือนคนโสด เพราะกิจกรรมช่วงนี้ของคุณและคนรักจะเป็นคนละแนวทางกัน แต่มีความเข้าใจกันเป็นอย่างดี ยังคงดูแลเอาใจใส่ในเรื่องต่าง ๆ เป็นที่ปรึกษาที่ดี ส่วนคนโสด มีความสุขแบบโสดสนิท",
          health:
            "ระวังอุบัติเหตุ หลีกเลี่ยงการขับขี่ขณะร่างกายไม่พร้อม มีเกณฑ์อาหารเป็นพิษ หน้ามืด วิงเวียน",
        },
        {
          job:
            "มีการสื่อสารที่เข้าใจไม่ตรงกันในบางครั้ง ทำให้เกิดปัญหางานชะงัก กิจการประเภทที่ต้องอาศัยแรงงานลูกน้อง ลูกจ้าง ค่อนข้างมีปัญหา ช่วงปลายเดือนปัญหาต่าง ๆ จะคลี่คลายได้สบายใจ",
          money:
            "ต้องประหยัดการใช้จ่าย หลีกเลี่ยงเรื่องที่เป็นความฟุ่มเฟือยเกินความจำเป็น รายได้ไม่ดีเหมือนที่ผ่านมา แม้มีเงินเดือนประจำ ก็จะมีเรื่องที่ถูกหักบางส่วน แต่ยังอยู่ในเกณฑ์ที่ไม่เดือดร้อน หากวางแผนดี ๆ",
          love:
            "ช่วงเวลาที่เรียกได้ว่าความรักเป็นเรื่องดีงาม คู่รักเข้าใจกัน คู่แต่งงานแล้วเตรียมตัวมีข่าวดีเรื่องลูก คนมีครอบครัวแล้ว บรรยากาศในบ้านอบอุ่นสุขใจ ส่วนคนโสด มีโอกาสสูงมากที่จะได้พบเจอคนที่ถูกใจใช่เลย",
          health:
            "มีอาการคล้าย ๆ ออฟฟิศซินโดรม ปวดเมื่อย ตึงคอ บ่า ไหล่ ตาพร่ามัวง่าย คันตา ตาแดงแพ้ฝุ่น",
        },
        {
          job:
            "ความที่มีเหตุผลปัจจัยอยู่นอกเหนือการควบคุมของคุณ ส่งผลกระทบต่อความต่อเนื่องของงาน ไม่สามารถดำเนินงานให้บรรลุตามเป้าหมายได้ทันเวลา ควรเตรียมแผนสำรองไว้สำหรับแก้ปัญหาเฉพาะหน้า",
          money:
            "ยังอยู่ในเกณฑ์ที่ไม่ต้องวิตกกังวล แม้ความสมดุลของรายได้-รายจ่ายค่อนข้างกระท่อนกระแท่น บางช่วงเรียกได้ว่าหายใจไม่ทั่วท้อง แต่คุณสามารถเอาตัวรอดได้หวุดหวิด จัดการภาระหนี้สินต่าง ๆ ได้ทันเวลา",
          love:
            "บรรยากาศครอบครัวราบรื่น ดูและเอาใจใส่กันดี คนที่มีคนรักคบหากันมาได้สักระยะ ช่วงนี้สถานะความสัมพันธ์จะชัดเจนขึ้น คนโสด มีคนอายุมากกว่าหลายปีเข้ามาทำความรู้จัก ใกล้ชิดเป็นพิเศษ",
          health:
            "หลีกเลี่ยงการกินอาหารเมนูเดิม ๆ ซ้ำ ๆ ไม่ควรนอนดึก ระบบย่อยอาหารไม่ค่อยดี ผิวพรรณไม่สดใส",
        },
      ],
    };
  },
  methods: {
    close() {
      this.$router.push("/thank");
    },
  },
  mounted() {
    if (this.$store.state.form.zodiac === "1") {
      this.prayer = require("../assets/zodiac/1.png");
      this.zodiacresult = this.result[0];
    } else if (this.$store.state.form.zodiac === "2") {
      this.zodiacresult = this.result[1];
      this.prayer = require("../assets/zodiac/2.png");
    } else if (this.$store.state.form.zodiac === "3") {
      this.zodiacresult = this.result[2];
      this.prayer = require("../assets/zodiac/3.png");
    } else if (this.$store.state.form.zodiac === "4") {
      this.zodiacresult = this.result[3];
      this.prayer = require("../assets/zodiac/4.png");
    } else if (this.$store.state.form.zodiac === "5") {
      this.zodiacresult = this.result[4];
      this.prayer = require("../assets/zodiac/5.png");
    } else if (this.$store.state.form.zodiac === "6") {
      this.zodiacresult = this.result[5];
      this.prayer = require("../assets/zodiac/6.png");
    } else if (this.$store.state.form.zodiac === "7") {
      this.zodiacresult = this.result[6];
      this.prayer = require("../assets/zodiac/7.png");
    } else if (this.$store.state.form.zodiac === "8") {
      this.zodiacresult = this.result[7];
      this.prayer = require("../assets/zodiac/8.png");
    } else if (this.$store.state.form.zodiac === "9") {
      this.zodiacresult = this.result[8];
      this.prayer = require("../assets/zodiac/9.png");
    } else if (this.$store.state.form.zodiac === "10") {
      this.zodiacresult = this.result[9];
      this.prayer = require("../assets/zodiac/10.png");
    } else if (this.$store.state.form.zodiac === "11") {
      this.zodiacresult = this.result[10];
      this.prayer = require("../assets/zodiac/11.png");
    } else if (this.$store.state.form.zodiac === "12") {
      this.zodiacresult = this.result[11];
      this.prayer = require("../assets/zodiac/12.png");
    }
  },
};
</script>

<style scoped>
.bg {
  /* background-image: url("../assets/background.jpg"); */
  background-repeat: no-repeat;
  background-size: 450px;
}
.headertext {
  padding-top: 40px;
  font-size: 20px;
  color: white;
}
.imgzodiac {
  width: 150px;
}
.box {
  margin-top: 50px;
  /* background-color: white;
  opacity: 0.3; */
}
.ttext {
  color: white;
  font-size: 20px;
}
.text {
  color: white;
  text-align: left;
  margin-left: 40px;
}
.x {
  position: absolute;
  margin-left: 90%;
  margin-top: 10px;
}
</style>
